import { TextField } from '@mui/material';
import { StandardTextFieldProps } from '@mui/material/TextField';
import { withStyles, WithStyles } from "@mui/styles";
import { InputColorStyles } from 'assets/jss/mui-extras/inputColorStyle';
import { MuiColors } from 'components/MuiExtras/Typography/MuiColor';
import * as React from 'react';


interface IProps extends Omit<StandardTextFieldProps, "InputProps"> {
    maxLength?: number;
    inputColor?: MuiColors,
    underlineColor?: MuiColors,
    startAdornment?: React.ReactNode;
    endAdornment?: React.ReactNode;
    onEnter?: () => void;
    onEscape?: () => void;
}

type Props = IProps & WithStyles<typeof InputColorStyles>;

const MuiTextFieldColor: React.FC<Props> = (props) => {

    const { classes, inputColor, maxLength, underlineColor, startAdornment, endAdornment, onEnter, onEscape, ...rest } = props;

    return (
        <TextField
            {...rest}
            InputProps={
                {
                    classes: {
                        root: inputColor ? classes["root_" + inputColor] : null,
                        underline: underlineColor ? classes.under + " " + classes["under_" + underlineColor] : null
                    },
                    startAdornment: startAdornment,
                    endAdornment: endAdornment,
                    onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => {
                        if (e.keyCode == 13 && onEnter) onEnter();
                        if (e.keyCode == 27 && onEscape) onEscape();
                    }
                }
            }
            inputProps={
                {
                    maxLength: maxLength
                }
            }

        />
    );
};


export default withStyles(InputColorStyles)(MuiTextFieldColor);